import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSectionBoot';
import DivLayout from 'components/sales/divLayout/divLayout';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import moment from 'moment';

const ManagePMSlot = ({
  fetchPmAssignee,
  postSchedulePM,
  pmAssigneeList,
  match,
  fetchPmSlotDetails,
  pmSlotDetails
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [maintenanceDate, setMaintenanceDate] = useState('');
  const [assigneeId, setassigneeId] = useState('');
  const [assigneeName, setassigneeName] = useState('');
  const [slotBooked, setSlotBooked] = useState('');
  const [isModal, setIsModal] = useState(false);
  const headerBtns = () => {
    return (
      <Fragment>
        <Link to="#" onClick={() => onAssign()} className="btn btn-primary">
          <img src={Images?.ArrowRight} alt=""></img>
          {`Submit`}
        </Link>
      </Fragment>
    );
  };
  console.log('test ' + JSON.stringify(pmSlotDetails));

  useEffect(() => {
     if(pmSlotDetails !== undefined && pmSlotDetails !== null) {
        if(pmSlotDetails?.maintenance_date !== null) {
           setMaintenanceDate(pmSlotDetails?.maintenance_date);
        }
        if(pmSlotDetails?.slot !== null) {
           setSlotBooked(pmSlotDetails?.slot);
        }
     }
  },[pmSlotDetails]);

  useEffect(() => {
    (async () => {
      const date =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].maintaince_date;
      handleDateChange(date);

      const assignee_id =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].assigned_to_id;

      // const slot_selection =
      //   (await JSON.parse(localStorage.getItem('viewDetail'))) &&
      //   JSON.parse(localStorage.getItem('viewDetail'))[0].slot;
      // if(slot_selection !== null && slot_selection !== undefined) {
      //   setSlotBooked(slot_selection);
      // }

      const assigneeName =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].assigned_to;
      // setMaintenanceDate(date);
      setassigneeId(assignee_id);
      setassigneeName(assigneeName);
    })();
  }, []);

  const onAssign = async () => {
    if (maintenanceDate !== '' && assigneeId !== '' && slotBooked !== '') {
      setIsLoading(true);
      const res = await postSchedulePM(
        match.params.manageId,
        maintenanceDate,
        assigneeId,
        slotBooked
      );

      setIsLoading(false);
      if (res === true) {
        setIsModal(true);
      } else setIsModal(false);
    }
  };

  const handleDateChange = (val) => {
    setMaintenanceDate(val);
  };

  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    (async () => {
      if (fetchPmAssignee) {
        setIsLoading(true);
        await fetchPmAssignee(match.params.id);
        await fetchPmSlotDetails(match.params.manageId);
        setIsLoading(false);
      }
    })();
  }, [fetchPmAssignee]);

  return (
    <Layout
      title={localization.managePm}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
      linkUrl={`${baseUrl}/pm-sities`}
    >
      <CardSection title={localization.schedulePm}>
      <div className="row">
          <div className="col-12">
              <div className="details-listing">
              <DivLayout
                heading={localization.currentMaintenanceDate}
                data={maintenanceDate}
              />
            </div>
          </div>
          </div>
          <div className="row">
            
            <div className="col-md-6 col-sm-12">
                <DatePicker
                  handleChange={handleDateChange}
                  value={moment(maintenanceDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                  label={localization.scheduleMaintenanceDate}
                  displayFormat="DD-MM-YYYY"
                  returnFormat="DD-MM-YYYY"
                  minimumDate={new Date()}
                  disabled={true}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <DropDownInput
                  label={localization.selectAssignee}
                  data={pmAssigneeList}
                  required
                  isStarRequired={true}
                  getIdValue={(val) => setassigneeId(val.id)}
                  value={assigneeName}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <DropDownInput
                  label={`Select Slot`}
                  data={[
                    {name: "09:00 am",id: "09:00 am"},
                    {name: "10:00 am",id: "10:00 am"},
                    {name: "11:00 am",id: "11:00 am"},
                    {name: "12:00 pm",id: "12:00 pm"},
                    {name: "13:00 pm",id: "13:00 pm"},
                    {name: "14:00 pm",id: "14:00 pm"},
                    {name: "15:00 pm",id: "15:00 pm"},
                    {name: "16:00 pm",id: "16:00 pm"},
                    {name: "17:00 pm",id: "17:00 pm"},
                    {name: "18:00 pm",id: "18:00 pm"},
                    {name: "19:00 pm",id: "19:00 pm"},
                    {name: "20:00 pm",id: "20:00 pm"},
                    {name: "21:00 pm",id: "21:00 pm"},
                  ]}
                  required
                  isStarRequired={true}
                  getIdValue={(val) => setSlotBooked(val.id)}
                  value={slotBooked}
                />
            </div>
          </div>

        
       
        
      </CardSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.assignedSuccessfully}</h5>
          <Link to={`${baseUrl}/pm-sities`} className="btn btn-primary mb-4">
            {localization.viewPmList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ManagePMSlot;
